import WindTooltip from './WindTooltip';

export default WindTooltip;
